/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDebtForecastGetAllResponseFromDiscriminatorValue, serializeDebtForecastPostRequest, type DebtForecastGetAllResponse, type DebtForecastPostRequest } from '../../models';
// @ts-ignore
import { type WithDebtForecastItemRequestBuilder, WithDebtForecastItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /debtforecasts/{currencyId}
 */
export interface WithCurrencyItemRequestBuilder extends BaseRequestBuilder<WithCurrencyItemRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.debtforecasts.item.item collection
     * @param debtForecastId Unique identifier of the item
     * @returns {WithDebtForecastItemRequestBuilder}
     */
     byDebtForecastId(debtForecastId: Guid) : WithDebtForecastItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DebtForecastGetAllResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DebtForecastGetAllResponse[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: DebtForecastPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DebtForecastPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCurrencyItemRequestBuilderUriTemplate = "{+baseurl}/debtforecasts/{currencyId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCurrencyItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCurrencyItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byDebtForecastId: {
        requestsMetadata: WithDebtForecastItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["debtForecastId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCurrencyItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCurrencyItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDebtForecastGetAllResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: WithCurrencyItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDebtForecastPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
